<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import WhatsappFlowsManager from './WhatsappFlowsManager.vue';

const route = useRoute();
const { t } = useI18n();

const initialInboxId = computed(() => String(route.query.inbox_id || ''));
const autoCreate = computed(() => route.query.new === '1');

const steps = computed(() => [
  {
    icon: 'i-hugeicons-task-edit-01',
    title: t('WHATSAPP_FLOWS.PAGE.STEP_CREATE_TITLE'),
    description: t('WHATSAPP_FLOWS.PAGE.STEP_CREATE_DESCRIPTION'),
  },
  {
    icon: 'i-hugeicons-checkmark-badge-01',
    title: t('WHATSAPP_FLOWS.PAGE.STEP_PUBLISH_TITLE'),
    description: t('WHATSAPP_FLOWS.PAGE.STEP_PUBLISH_DESCRIPTION'),
  },
  {
    icon: 'i-hugeicons-git-branch',
    title: t('WHATSAPP_FLOWS.PAGE.STEP_USE_TITLE'),
    description: t('WHATSAPP_FLOWS.PAGE.STEP_USE_DESCRIPTION'),
  },
]);
</script>

<template>
  <main class="h-full min-h-0 w-full overflow-y-auto bg-n-surface-1">
    <div
      class="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-6 pb-24 sm:px-6 sm:py-8"
    >
      <header class="flex items-start gap-4">
        <span
          class="grid size-12 shrink-0 place-items-center rounded-xl bg-n-teal-3 text-n-teal-11"
        >
          <span class="i-hugeicons-workflow-square-06 size-6" />
        </span>
        <div class="min-w-0">
          <p
            class="mb-1 text-xs font-semibold uppercase tracking-wide text-n-brand"
          >
            {{ t('WHATSAPP_FLOWS.PAGE.EYEBROW') }}
          </p>
          <h1 class="mb-2 text-2xl font-semibold text-n-slate-12">
            {{ t('WHATSAPP_FLOWS.TITLE') }}
          </h1>
          <p class="mb-0 max-w-3xl text-sm text-n-slate-11">
            {{ t('WHATSAPP_FLOWS.PAGE.DESCRIPTION') }}
          </p>
        </div>
      </header>

      <ol
        class="m-0 grid list-none gap-3 p-0 md:grid-cols-3"
        :aria-label="t('WHATSAPP_FLOWS.PAGE.STEPS_LABEL')"
      >
        <li
          v-for="(step, index) in steps"
          :key="step.title"
          class="flex items-start gap-3 rounded-xl border border-n-weak bg-n-solid-1 p-4"
        >
          <span
            class="grid size-9 shrink-0 place-items-center rounded-lg bg-n-alpha-2 text-n-slate-12"
          >
            <span class="size-4" :class="step.icon" />
          </span>
          <div class="min-w-0">
            <p class="mb-1 text-sm font-semibold text-n-slate-12">
              {{ index + 1 }}. {{ step.title }}
            </p>
            <p class="mb-0 text-xs leading-5 text-n-slate-11">
              {{ step.description }}
            </p>
          </div>
        </li>
      </ol>

      <WhatsappFlowsManager
        :initial-inbox-id="initialInboxId"
        :auto-create="autoCreate"
      />
    </div>
  </main>
</template>
